import Vue from "vue"
import VueRouter, { RouteConfig } from "vue-router"
import { setupGuards, navigationContextGuard, roleCheckingGuard } from "./guards"

import { authRoutes } from "./routes/auth"
import { adminRoutes } from "./routes/admin"
import { companyRoutes } from "./routes/company"
import { externalRoutes } from "./routes/external"
import { globalSettingsRoutes } from "./routes/global-settings"
import { locationGroupRoutes } from "./routes/location-group"
import { locationRoutes } from "./routes/location"
import { pricingRoutes } from "./routes/pricing"
import { setupRoutes } from "./routes/setup"
import { userRoutes } from "./routes/user"
import { timeOfUseRoutes } from "./routes/time-of-use"
import { pricingPlansRoutes } from "./routes/pricing-plans"

import DashView from "@/components/layout/Dash.vue"
import NotFoundView from "@/views/404.vue"
import DashboardView from "@/views/Dashboard.vue"

Vue.use(VueRouter)

export const DEFAULT_DOCUMENT_TITLE = "Cloud"

const mainRoutes: RouteConfig[] = [
    {
        path: "/",
        component: DashView,
        meta: { auth: true },
        children: [
            {
                path: "overview",
                name: "Dashboard",
                component: DashboardView,
                meta: { title: "Overview" },
            },
            ...adminRoutes,
            ...externalRoutes,
            ...locationRoutes,
            ...locationGroupRoutes,
            ...companyRoutes,
            ...pricingRoutes,
            ...userRoutes,
            ...timeOfUseRoutes,
            ...pricingPlansRoutes,
        ],
    },
    ...authRoutes,
    ...setupRoutes,
    ...globalSettingsRoutes,
    { path: "*", name: "NotFound", component: NotFoundView, meta: { title: "Not Found" } },
]

if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "staging") {
    const rootRoute = mainRoutes.find((route) => route.path === "/")

    if (rootRoute && rootRoute.children) {
        rootRoute.children.push({
            path: "user/settings/oem",
            name: "oem-settings",
            component: () => import("@/views/OemSettingsView.vue"),
            meta: { title: "OEM Settings" },
        })
    }
}

const router = new VueRouter({
    mode: "history",
    base: __dirname,
    routes: mainRoutes,
})

setupGuards(router)
router.beforeEach(navigationContextGuard)
router.beforeEach(roleCheckingGuard)

export default router
